import * as yup from 'yup';
import { AudioFormValidationProperties, AudioTypesDDL } from 'types/audio';
import { fieldValidationMessages } from 'app/constants';
import { PostSongAudioEffectData } from 'app/store/SongList/effects.types';
import { Option } from 'types/general.types';
import { AudioFormData, AudioFormItem } from './types';

export const transformAudioTypesToOptions = (
  audioTypes: AudioTypesDDL
): Option[] =>
  Object.values(audioTypes).map((type) => ({
    title: type.name,
    value: type.key,
  }));

export const getValidationSchema = (
  audioFormValidation: AudioFormValidationProperties
) =>
  yup.object().shape({
    filesMeta: yup.array().of(
      yup.object().shape({
        title: yup
          .string()
          .required(fieldValidationMessages.REQUIRED)
          .max(
            audioFormValidation.title.maxLength,
            fieldValidationMessages.MAX_CHAR(
              audioFormValidation.title.maxLength
            )
          )
          .trim(),
        remark: yup
          .string()
          .max(
            audioFormValidation.remark.maxLength,
            fieldValidationMessages.MAX_CHAR(
              audioFormValidation.remark.maxLength
            )
          )
          .trim(),
        type: yup
          .object()
          .required(fieldValidationMessages.REQUIRED)
          .nullable(),
      })
    ),
  });

export const getDefaultValues = (
  validation: AudioFormValidationProperties,
  audioTypesOptions: Option[],
  fileList?: FileList
): AudioFormData => {
  const values = { filesMeta: [] } as AudioFormData;
  if (fileList) {
    Array.from(fileList).forEach((file, index) => {
      values.filesMeta[index] = {
        remark: '',
        title: file.name || '',
        type:
          audioTypesOptions.find(
            (option) => option.value === validation.type.default
          ) || '',
        isPrivate: false,
      };
    });
  }

  return values;
};

export const formatAudioFileMetaData = (
  dirtyValues: AudioFormItem
): PostSongAudioEffectData['fileMeta'] => {
  const transformedData: PostSongAudioEffectData['fileMeta'] = {
    ...dirtyValues,
    type: (dirtyValues.type as Option).value as string,
  };
  const filteredData = Object.fromEntries(
    Object.entries(transformedData).filter(([, v]) => v != null && v !== '')
  );

  return filteredData;
};
